export default {
  title: 'Nueva marca',
  tabs: {
    general: 'General',
    branding: 'Branding',
    scripts: 'Scripts',
    tracking: 'Seguimiento',
    domain: 'Dominio',
  },
  fields: {
    name: {
      label: 'Nombre',
      placeholder: 'Nombre de la marca',
    },
    slug: {
      label: 'Subdominio',
      placeholder: 'Subdominio de la marca',
      hint: 'Letras minúsculas, números y guiones. Junto con el dominio de la tienda forma la dirección de la tienda.',
      preview: 'Dirección de la tienda: {{url}}',
      availability: {
        taken: 'Otra marca ya usa este subdominio en este dominio de tienda.',
        reserved: 'Este subdominio está reservado. Elige otro.',
        invalid_label:
          'En este dominio de tienda, el subdominio solo puede tener letras minúsculas, números y guiones, debe empezar y terminar con una letra o un número y puede tener como máximo 63 caracteres.',
        taken_elsewhere: 'Una marca de otro dominio de tienda ya usa este subdominio. Elige otro.',
        format: 'Usa solo letras, números, guiones y guiones bajos.',
        unavailable: 'Este subdominio no está disponible. Elige otro.',
      },
    },
    shop_domain_id: {
      label: 'Dominio de la tienda',
      placeholder: 'Selecciona un dominio de tienda',
      move_warning: {
        title: 'Esto cambia la dirección de la tienda que usan los clientes',
        description:
          'Al guardar, la tienda estará en {{url}}. Los códigos QR, folletos y enlaces ya impresos o compartidos con la dirección anterior dejarán de funcionar.',
      },
    },
    lieferando_url: {
      label: 'URL de Lieferando',
      placeholder: 'URL del restaurante en Lieferando',
    },
    primary_color: {
      label: 'Color principal',
    },
    logo: {
      label: 'Logo',
    },
    image: {
      label: 'Imagen',
    },
    companies: {
      label: 'Restaurantes',
    },
    noscripts: {
      description: 'Inyectar código justo después de abrir el body',
    },
    facebook_pixel: {
      label: 'Facebook Pixel',
    },
    facebook_conversion_api_access_token: {
      label: 'Token de acceso de conversión de Facebook',
    },
    google_analytics_id: {
      label: 'ID de Google Analytics',
    },
    google_ads_conversion_label_id: {
      label: 'Etiqueta de conversión de Google Ads',
    },
    // Named in the modal's error summary when the domain is refused.
    online_shop_domain: {
      label: 'Dominio propio para la tienda online',
    },
  },
  buttons: {
    save: 'Guardar',
    close: 'Cerrar',
    sync_from_lieferando: 'Sincronizar desde Lieferando',
  },
  toasts: {
    changes_saved_successfully: '¡Los cambios se han guardado correctamente!',
    failed_to_update_company_slug: 'Error al actualizar el slug de {{name}}',
    failed_to_sync_lieferando: 'Error al sincronizar datos desde Lieferando',
    successfully_synced_lieferando: 'Datos sincronizados correctamente desde Lieferando',
    failed_to_load_shop_domains: 'No se pudieron cargar los dominios de tienda.',
  },
};
